// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".atom-tenant{align-items:center;display:flex;flex-wrap:wrap;justify-content:center}.atom-tenant a{display:inline-block;margin-right:4.375rem;padding:.938rem 0;vertical-align:middle}@media only screen and (max-width:767px){.atom-tenant a{margin:15px}}.atom-tenant img{max-height:4.063rem;max-width:8.438rem}@media only screen and (max-width:767px){.atom-tenant img{max-height:25px;max-width:120px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
